'use client';

import React, { useEffect } from 'react';
import PencilLineIcon from 'remixicon-react/PencilLineIcon';
import { useRouter } from 'next/navigation';
import useStore from '@/stores/admin/PostIDStore';
import useStoreID from '@/stores/admin/IDStore';
import Image from 'next/image';
import { User } from 'iconsax-react';

const AdminTopbar: React.FC = () => {
    // Access postId from IDStore
    const pageId = useStoreID((state) => state.postId);
    const router = useRouter();

    // Access authentication-related state and actions from AuthStore
    const { authToken, user, initializeAuth, logout } = useStore();

    useEffect(() => {
        initializeAuth();
    }, [initializeAuth]);

    // Handler to redirect to the edit page
    const handleEdit = () => {
        if (pageId === null) {
            console.error('No post ID available for editing.');
            return;
        }
        const editUrl = `https://panel.khanesarmaye.com/wp-admin/post.php?post=${pageId}&action=edit`;
        window.open(editUrl, '_blank', 'noopener,noreferrer');
    };

    // Handler to log out the user
    const handleLogout = () => {
        logout();
        router.push('/');
    };

    // If the user is not authenticated, do not render the topbar
    if (!authToken) return null;

    return (
        <div className='fixed flex bg-bg rounded-2xl z-30 gap-10 py-1 bottom-4 right-4 border-2 border-primary/10'>
            <div className='container inline-flex gap-24 items-center justify-between px-2'>
                <div className='inline-flex items-center gap-2 text-sm text-primary'>
                    {user?.avatar?.url ? (
                        <Image
                            src={user?.avatar?.url || ''}
                            alt={user?.name || 'admin_logo'}
                            width={22}
                            height={22}
                            className='rounded-full'
                        />
                    ) : (
                        <User
                            size={26}
                            className={
                                'stroke-primary/50 border border-primary/50 rounded-full p-1'
                            }
                            variant={'Bold'}
                        />
                    )}
                    {user && <span>{user?.firstName + ' ' + user?.lastName}</span>}
                    <div
                        className='inline-flex cursor-pointer items-center gap-2 transition-all duration-300 hover:px-5 bg-green-500 px-2 rounded-xl text-white'
                        onClick={handleEdit}
                    >
                        <PencilLineIcon size={16} />
                        ویرایش نوشته
                    </div>
                </div>

                <button
                    onClick={handleLogout}
                    className='rounded-xl bg-error px-3 text-sm text-white hover:bg-red-700'
                >
                    خروج
                </button>
            </div>
        </div>
    );
};

export default AdminTopbar;
